import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { RegisterModel } from '../models/register.model';
import { RegisterRepository } from '../repositories/register.repository';
import { AuthIntegrationType } from '../config/enums/auth-integration-type.enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(
    private registerRepository: RegisterRepository
  ) { }

  public registerCostumer(registerForm: RegisterModel, recaptchaToken: string): Observable<RegisterModel> {
    return this.registerRepository.registerCostumer(registerForm, recaptchaToken);
  }

  generateValidationCode(params: any, captcha: string) {
    return this.registerRepository.generateValidationCode(params, captcha);
  }

  checkValidationCode(params: any) {
    return this.registerRepository.checkValidationCode(params);
  }

  checkAuthIntegration(cpf: string) {
    const type = environment.authIntegration.type;
    const referencialId = environment.authIntegration.referencialId;
    return this.registerRepository.checkAuthIntegration(cpf, type, referencialId);
  }

}
